import { dateRangePickerDayClasses, pickersDayClasses } from '@mui/x-date-pickers-pro';
/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * MuiPickersDay to make it match the design system.
 *
 * See: https://mui.com/x/api/date-pickers/pickers-day/#classes
 */ const borderRadius = '4px';
export const MuiPickersDay = {
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.text.primary,
                borderRadius,
                width: '36px',
                height: '24px',
                // Ensure that DateRangePickerDay and PickersDay are identical
                [`&:not(.${dateRangePickerDayClasses.day})`]: {
                    margin: '2px !important',
                    transform: 'scale(1.1)'
                },
                '&:hover': {
                    backgroundColor: theme.palette.background.hover
                },
                [`&.${pickersDayClasses.dayOutsideMonth}`]: {
                    color: theme.palette.text.disabled
                },
                [`&.${pickersDayClasses.today}`]: {
                    borderColor: theme.palette.primary.main
                },
                [`&.${pickersDayClasses.selected}`]: {
                    background: theme.palette.primary.main
                }
            })
    }
};

//# sourceMappingURL=pickers-day-overrides.js.map